import React, {useState, useEffect} from 'react';
import {NavLink} from "react-router-dom";
import '../../assets/css/card-slider.css';
import arrowImg from '../../assets/images/icons/errow.png';
import Slider from 'react-slick';
import h5GamesJsonData from "../data/h-five-games.json";
import Loader from "./Loader";


const HFiveGameSlider = (props) => {
    const [h5Games, setH5Games] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setH5Games(Object.values(h5GamesJsonData));
        setLoading(false);
    }, []);

    const windowWidth = window.innerWidth;
    let slidesToShow = 3.999;
    if (windowWidth > 850 && windowWidth <= 900) {
        slidesToShow = 2.999;
    } else if (windowWidth <= 850) {
        slidesToShow = 1;
    }
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 10000,
    };

    return (
        <section>
            <div className="mt-4 cards-wrapper card-slider-wrapper play-game-slider">
                <div className="card-slider-heading">
                    <h2 className="headingz mb-4">Play
                        <span className="errow-icon">
                            <img src={arrowImg} alt="errow-img"/>
                        </span>
                    </h2>
                    <p className="main-slider-heading">Instant Game Plays</p>
                </div>

                {loading ? (
                    <Loader/>
                ) : (
                    <Slider {...settings} className="slider card-slider arrow-light slider-gap sliderz">
                        {h5Games.length > 0 && h5Games.map((h5Game, index) => (
                            <NavLink key={index} to={`/play-games/${index}`}>
                                <div className="cards-round">
                                    <img className="card-img" src={window.location.origin + h5Game.thumbnail}
                                         alt="h5-img"/>
                                    <div className="cards-info">
                                        <h3 className="cards-label text-white">
                                            {h5Game.name}
                                        </h3>
                                    </div>
                                </div>
                            </NavLink>
                        ))}
                    </Slider>
                )}

                {h5Games.length < 1 && (
                    <div className="d-flex justify-content-center align-items-center no-data-found">
                        <p>No H5 games found</p>
                    </div>
                )}

            </div>
        </section>
    );
}

export default HFiveGameSlider;
